export default "__VITE_ASSET__84e58580__"